import { FMDPStorage } from "./helper";

const defaultLanguage = "en";

export function getPreferredLanguage(currentUser = FMDPStorage.get("current-user")) {
  return FMDPStorage.get("user-language") || currentUser?.locale?.code || defaultLanguage;
}

export function storePreferredLanguage(currentUser, language) {
  if (!language?.code) return;
  FMDPStorage.set("current-user", { ...currentUser, locale: language });
  FMDPStorage.set("user-language", language.code);
}

export async function persistPreferredLanguage({
  currentUser,
  language,
  updateProfile,
  reload = () => window.location.reload(),
}) {
  await updateProfile({
    id: currentUser?.id,
    formData: {
      first_name: currentUser?.first_name,
      last_name: currentUser?.last_name,
      locale_id: language?.id,
    },
  });

  storePreferredLanguage(currentUser, language);
  reload();
}

export class TranslationHelper {
  constructor() {
    this.supportedLanguages = [];
    this.translationObj = {};
    this.localizations = {};
    this.currentLanguage = getPreferredLanguage();
  }

  setSupportedLanguage(languageList) {
    this.supportedLanguages = Array.isArray(languageList) ? languageList : languageList?.data || [];
  }

  setTranslationObj(translationObj) {
    this.translationObj = translationObj || {};
  }

  setLocalizations(localizations) {
    this.localizations = localizations || {};
  }

  isLanSupported(language) {
    return this.supportedLanguages.findIndex((lan) => lan?.code === language) >= 0;
  }

  changeLanguage(newLan) {
    if (this.isLanSupported(newLan) && this.currentLanguage !== newLan) {
      FMDPStorage.set("user-language", newLan);
      this.currentLanguage = newLan;
      return true;
    }
    return false;
  }

  get(key) {
    return this.translationObj[key] || {};
  }

  getLocalization(key) {
    return this.localizations[key] || {};
  }
}

export const tHelper = new TranslationHelper();
export const translator = {};

export function getLocalizedString(id, defaultValue) {
  try {
    return JSON?.parse(tHelper?.localizations)[id] || defaultValue;
  } catch {
    return defaultValue;
  }
}
